import { useEffect, useState } from "react";
import Nav from "../components/landing/Nav";
import AnnouncementBar from "../components/landing/AnnouncementBar";
import LiveTicker from "../components/landing/LiveTicker";
import Hero from "../components/landing/Hero";
import TrustBar from "../components/landing/TrustBar";
import Problem from "../components/landing/Problem";
import Features from "../components/landing/Features";
import Dashboard from "../components/landing/Dashboard";
import Comparison from "../components/landing/Comparison";
import HowItWorks from "../components/landing/HowItWorks";
import WhoFor from "../components/landing/WhoFor";
import Bonuses from "../components/landing/Bonuses";
import Proof from "../components/landing/Proof";
import BrandAuthority from "../components/landing/BrandAuthority";
import Guarantee from "../components/landing/Guarantee";
import Pricing from "../components/landing/Pricing";
import FAQ from "../components/landing/FAQ";
import FinalCTA from "../components/landing/FinalCTA";
import SEOContent from "../components/landing/SEOContent";
import RiskDisclaimer from "../components/landing/RiskDisclaimer";
import Footer from "../components/landing/Footer";
import StickyCTA from "../components/landing/StickyCTA";
import ExitIntent from "../components/landing/ExitIntent";
import LocaleModal from "../components/landing/LocaleModal";
import CashfreeCheckout from "../components/landing/CashfreeCheckout";
import { trackViewContent, trackEvent } from "../config";
import { useI18n } from "../i18n";

export default function Landing() {
  const { currency } = useI18n();
  const [cashfreeOpen, setCashfreeOpen] = useState(false);
  const [cashfreePrefill, setCashfreePrefill] = useState({});

  useEffect(() => {
    trackEvent("page_view", { page_title: document.title });
    trackViewContent(currency.code, currency.price);
    const points = [25, 50, 75, 90];
    const fired = new Set();
    const onScroll = () => {
      const pct = (window.scrollY / (document.body.scrollHeight - window.innerHeight)) * 100;
      points.forEach((p) => {
        if (pct >= p && !fired.has(p)) {
          fired.add(p);
          trackEvent("scroll_depth", { percent: p });
        }
      });
    };
    window.addEventListener("scroll", onScroll, { passive: true });
    const onOpen = (e) => { setCashfreePrefill(e.detail || {}); setCashfreeOpen(true); };
    window.addEventListener("dppg:open-cashfree", onOpen);
    return () => {
      window.removeEventListener("scroll", onScroll);
      window.removeEventListener("dppg:open-cashfree", onOpen);
    };
  }, [currency.code, currency.price]);

  return (
    <div data-testid="landing-page" className="relative">
      <AnnouncementBar />
      <Nav />
      <main>
        <Hero />
        <LiveTicker />
        <TrustBar />
        <Problem />
        <Features />
        <Dashboard />
        <Comparison />
        <HowItWorks />
        <WhoFor />
        <Proof />
        <BrandAuthority />
        <Bonuses />
        <Guarantee />
        <Pricing />
        <FAQ />
        <FinalCTA />
        <SEOContent />
        <RiskDisclaimer />
      </main>
      <Footer />
      <StickyCTA />
      <ExitIntent />
      <LocaleModal />
      <CashfreeCheckout
        open={cashfreeOpen}
        defaultEmail={cashfreePrefill.email || ""}
        defaultName={cashfreePrefill.name || ""}
        defaultPhone={cashfreePrefill.phone || ""}
        onClose={() => setCashfreeOpen(false)}
      />
    </div>
  );
}
